/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_1_LInputs */

const en_mk_proof_1_l = /** @type {(inputs: Mk_Proof_1_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`projects, conversations, agents, and company knowledge`)
};

const id_mk_proof_1_l = /** @type {(inputs: Mk_Proof_1_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`proyek, percakapan, agen, dan pengetahuan perusahaan`)
};

/**
* | output |
* | --- |
* | "projects, conversations, agents, and company knowledge" |
*
* @param {Mk_Proof_1_LInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_1_l = /** @type {((inputs?: Mk_Proof_1_LInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_1_LInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_1_l(inputs)
	return en_mk_proof_1_l(inputs)
});